var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.656 22h-10.625c-1.2925 0-2.3438-1.0513-2.3438-2.3438v-10.625c0-1.2925 1.0513-2.3438 2.3438-2.3438h10.625c1.2925 0 2.3438 1.0513 2.3438 2.3438v10.625c0 1.2925-1.0513 2.3438-2.3438 2.3438zm-10.625-13.75c-0.4308 0-0.78126 0.35046-0.78126 0.78126v10.625c0 0.43078 0.35046 0.78126 0.78126 0.78126h10.625c0.43078 0 0.78126-0.35048 0.78126-0.78126v-10.625c0-0.4308-0.35048-0.78126-0.78126-0.78126zm-3.9063 7.5h-0.78124c-0.4308 0-0.78126-0.35046-0.78126-0.78126v-10.625c0-0.4308 0.35046-0.78126 0.78126-0.78126h10.625c0.4308 0 0.78126 0.35046 0.78126 0.78126v0.74219h1.5625v-0.74219c0-1.2925-1.0512-2.3438-2.3438-2.3438h-10.625c-1.2925 0-2.3438 1.0513-2.3438 2.3438v10.625c0 1.2925 1.0513 2.3438 2.3438 2.3438h0.78124z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ea58009ea5b0c217b8cfb7b6822c6144.svg";
export { ForwardRef as ReactComponent };